import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionDetailsComponent } from './auction-details.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorComponent, ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RouterModule } from '@angular/router';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { DirectivesModule, IfItemEnabled } from '@fgb/portal-component-library/src/lib/directives';
import { SocialShareModalModule } from '@fgb/portal-component-library/src/lib/shared/social-share-modal';
import { AuctionPurchaseConfirmationComponent } from './auction-purchase-confirmation/auction-purchase-confirmation.component';
import { RewardStatusComponent } from '@fgb/portal-component-library/src/lib/loyalty/reward-status';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AuctionDetailsComponent],
  imports: [
    CommonModule,
    ErrorsModule,
    RewardStatusComponent,
    NumberInputModule,
    ShortLongDescriptionModule,
    PipesModule,
    LoyaltyIconModule,
    CountdownModule,
    IfItemEnabled,
    DirectivesModule,
    AuctionPurchaseConfirmationComponent,
    RouterModule,
    NgbCarouselModule,
    FormsModule,
    FGBSharedModule,
    ErrorComponent,
    ReactiveFormsModule,
    SocialShareModalModule,
  ],
  exports: [AuctionDetailsComponent],
})
export class AuctionDetailsModule {}
